import { createElement, useEffect, useState, useCallback } from 'react';
import { Table, Button, Notification } from '@alifd/next';
import request from '@/utils/request';
import JsonSchemaEditor from './jsonSchemaEditor';
import Pagination from '@/components/table/pro-table/edit-table/components/pagination';
const RunDrawer = (props) => {
    const { rowRecord } = props;
    const { bizEventCd, businessEntityCode } = rowRecord;
    const [schema, setSchema] = useState('{}');
    const [json, setJson] = useState('{}');
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [pageParams, setPageParams] = useState({
        pageSize: 10,
        pageNo: 1,
    });
    const [total, setTotal] = useState(0);
    const [isReset, setIsReset] = useState(false);
    const querySchema = useCallback(async () => {
        const { content } = await request(`/api/exchange/entity/extend/${businessEntityCode}`);
        const schemaSource = JSON.parse(content?.bigData?.dataContent || '{}');
        setSchema(schemaSource);
    }, [businessEntityCode]);
    useEffect(() => {
        querySchema();
    }, [querySchema]);
    const onChange = (val) => {
        setJson(val);
    };
    const run = () => {
        setLoading(true);
        request
            .post('/api/account/bizEvent/execute', {
            bizEventEntityJson: JSON.stringify(json),
            bizEventCd
        })
            .then(({ content = [] }) => {
            setDataSource(content);
            setTotal(content.length);
            Notification.success({
                title: '运行成功',
            });
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const reset = () => {
        querySchema();
        setJson('{}');
        setIsReset(true);
    };
    const onPageChange = (pageParams) => {
        setPageParams((state) => ({
            ...state,
            ...pageParams,
        }));
    };
    return (createElement("div", { style: { width: '100%', } },
        createElement("div", { className: "input", style: {
                border: '1px solid rgb(240,240,240)',
                padding: '20px',
                overflow: 'auto',
            } },
            createElement("div", null,
                createElement(JsonSchemaEditor, { data: schema, onChange: onChange, isReset: isReset }),
                createElement(Button.Group, { style: { display: 'flex', justifyContent: 'center' } },
                    createElement(Button, { style: { marginTop: '10px' }, onClick: run, loading: loading }, "\u8FD0\u884C"),
                    createElement(Button, { style: { marginTop: '10px' }, onClick: reset }, "\u91CD\u7F6E")))),
        createElement("div", { className: "output", style: {
                border: '1px solid rgb(240,240,240)',
                padding: '10px',
                overflow: 'auto',
                marginTop: '10px'
            } },
            createElement(Table, { dataSource: dataSource, primaryKey: "uid" },
                createElement(Table.Column, { title: "\u5206\u5F55\u5E8F\u53F7", dataIndex: "entrySeq" }),
                createElement(Table.Column, { title: "\u501F\u8D37\u65B9\u5411", dataIndex: "crDbFlg" }),
                createElement(Table.Column, { title: "\u79D1\u76EE\u540D\u79F0", dataIndex: "subjectName" }),
                createElement(Table.Column, { title: "\u4EA4\u6613\u91D1\u989D", dataIndex: "amount" }),
                createElement(Table.Column, { title: "\u6458\u8981", dataIndex: "abstracts" })),
            createElement(Pagination, { onChange: onPageChange, total: total }))));
};
export default RunDrawer;
